import { useEffect, useState } from 'react'
import { AlertCircle, CheckCircle } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import { Alert, Container, Spinner } from 'reactstrap'

import SidebarWithdraw from 'features/private-views/dashboard/SidebarWithdraw'
import {
  toggleBanner,
  toggleSidebarWithdraw,
} from 'features/private-views/dashboard/dashboardSlice'
import { initializeTemplate } from 'features/private-views/homepage/homepageSlice'
import Verification from 'features/private-views/verification/Verification'
import { setSuccessPindahUangUsaha } from 'features/private-views/withdraw/withdrawSlice'
import SidebarConfirm from 'private-views/dashboard/SidebarConfirm'

// Import dynamic components
import DynamicHeader from 'components/homepage/DynamicHeader'
import FloatingConfigButton from 'components/homepage/FloatingConfigButton'
import JsonWidgetRenderer from 'components/homepage/JsonWidgetRenderer'
import TemplateConfigModal from 'components/homepage/TemplateConfigModal'
import { getTemplates } from '../../../config/templateConfig'

const Homepage = () => {
  const profile = useOutletContext()
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false)

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  const toggleConfigModal = () => {
    setIsConfigModalOpen(!isConfigModalOpen)
  }

  useEffect(() => {
    const userRole = profile?.data?.makerData?.role || 'user'
    dispatch(initializeTemplate({ userRole, userProfile: profile }))
  }, [dispatch, profile])

  const pindahUangUsaha = useSelector((s) => s.withdraw)
  const { isOpenSidebarWithdraw, isOpenBanner, bannerMessage, bannerType } =
    useSelector((e) => e.dashboard)

  // Get template from backend profile or fallback to dev config
  const currentTemplate = profile?.data?.homeTemplate

  // Try to safely get userId for the JSON payload generator
  const currentUserId = profile?.data?.id || profile?.data?.makerData?.id || 236

  return (
    <Container fluid>
      <SidebarWithdraw
        open={isOpenSidebarWithdraw}
        toggle={() => dispatch(toggleSidebarWithdraw())}
      />
      <SidebarConfirm open={isOpen} toggleSidebar={toggleSidebar} />

      <DynamicHeader profile={profile} />

      <Verification profile={profile} />

      <Alert
        isOpen={
          pindahUangUsaha?.handlePindahUangUsaha?.message === '' ? false : true
        }
        className="mt-3"
        color="success"
        toggle={() => dispatch(setSuccessPindahUangUsaha({ message: '' }))}
      >
        <CheckCircle className="text-success me-2" size={16} />
        <span>{pindahUangUsaha?.handlePindahUangUsaha?.message}</span>
      </Alert>

      <Alert
        className="mt-3"
        color={bannerType}
        isOpen={isOpenBanner}
        toggle={() => dispatch(toggleBanner())}
      >
        {bannerType === 'success' ? (
          <CheckCircle className="text-success me-2" size={16} />
        ) : (
          <AlertCircle className="text-danger me-2" size={16} />
        )}
        <span>{bannerMessage}</span>
      </Alert>

      {/* JSON Widget Renderer - Using templateConfig */}
      <JsonWidgetRenderer config={currentTemplate} />

      {/* Template Configuration Modal */}
      <TemplateConfigModal
        isOpen={isConfigModalOpen}
        toggle={toggleConfigModal}
        profileTemplate={profile?.data?.homeTemplate}
        userId={currentUserId}
      />
    </Container>
  )
}

export default Homepage
